import { DisplayGroupValue } from 'src/models/formsHandler/formsHandler';
import { resolveValueFunctionFormula } from 'src/utils/resolveValueFunctionFormula';

export function resolveValueFunction(displayGroupValue: DisplayGroupValue): string {
  return `~Value(${resolveValueFunctionFormula(displayGroupValue)}, ${!!displayGroupValue.value.forceUpdate})`
}
